import { render } from "./UploadImageComponent.vue?vue&type=template&id=242df985"
import script from "./UploadImageComponent.vue?vue&type=script&lang=js"
export * from "./UploadImageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__